<template>
  <div class="pricemonitoring-page">
    <PageProductCharts />
    <PageProductTable />
  </div>
</template>

<script>
import PageProductCharts from '@/components/SPU/PriceMonitoring/PageProductCharts.vue'
import PageProductTable from '@/components/SPU/PriceMonitoring/PageProductTable.vue'
export default {
  components: {
    PageProductCharts,
    PageProductTable
  },

}
</script>
